import { GTIWebDataGrid, Stack, Box, GTIWebButton, Refresh, Typography } from "@gti-controls-v2/web-core";
import consumosStyles from "../../../common/styles/Consumos";
import { useMediaQueryCustom } from "../../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import useTranslation from "../../../hooks/useTranslation";
import { fontSize } from "../../../common/constants/UI";
import appConfig from "../../../config/app";
import avatar from "../../../assets/avatar.svg";
import { formatDate } from "../../../common/utilities/dateTime";
import { timeFormathhmmAMPM } from "../../../common/constants/Formatos";
import ImageWithRetry from "../../../components/ImageWithRetry/ImageWithRetry";

const styles = consumosStyles;

export const ConsumosGrid = (props) => {

    const { isMobile480, isTablet768, isTablet1024, isLaptopDesktop } = useMediaQueryCustom();
    const { t } = useTranslation();

    let columns = [];

    const renderCellFoto = (params) => {
        if (params.value && params.value !== '/Revolution') {
            return <ImageWithRetry
                //src={params.value}
                src={params.value.replace("/Revolution~", appConfig.APP_URL)}
                notFoundSrc={avatar}
                width={(isMobile480 || isTablet768) ? 82 : isTablet1024 ? 112 : 152}
                height={(isMobile480 || isTablet768) ? 82 : isTablet1024 ? 112 : 152}
                alt={t("sistema.titulos.empleado")}
                style={{ borderRadius: "10%" }}
            />;
        }
        else {
            return <img
                src={avatar}
                width={(isMobile480 || isTablet768) ? 82 : isTablet1024 ? 112 : 152}
                height={(isMobile480 || isTablet768) ? 82 : isTablet1024 ? 112 : 152}
                alt={t("sistema.titulos.empleado")}
                style={{ borderRadius: "10%" }} />;
        }
    }

    if (isMobile480 || isTablet768) {
        columns = [
            {
                field: "Foto",
                headerName: t("sistema.consumos.grid.foto"),
                align: "center",
                width: "25%",
                renderCell: (params) => {
                    return renderCellFoto(params);
                },
                sortable: false
            },
            {
                field: "Consumo",
                headerName: t("sistema.consumos.grid.consumo"),
                width: "75%",
                sortable: false,
                renderCell: (params) => {
                    return <>
                        <Stack direction="column">
                            <Typography sx={{ textWrap: "wrap" }} fontSize={fontSize.isMobile480}>{`${params.row.EmpNumero} - ${params.row.PersonaName}`}</Typography>
                            <Typography fontSize={fontSize.isMobile480}>{params.row.PuestoNombre}</Typography>
                            <Typography sx={{ textWrap: "wrap" }} fontSize={fontSize.isMobile480}>{`${formatDate(params.row.CafeDocStamp, timeFormathhmmAMPM)} - ${params.row.CafeProdNombre}`}</Typography>
                        </Stack>
                    </>
                }
            },
        ]
    }

    if (isTablet1024 || isLaptopDesktop) {
        columns = [
            {
                field: "Foto",
                headerName: t("sistema.consumos.grid.foto"),
                align: "center",
                width: "20%",
                sortable: false,
                renderCell: (params) => {
                    return renderCellFoto(params);
                },
            },
            {
                field: "EmpNumero",
                align: "right",
                headerName: t("sistema.consumos.grid.numero"),
                width: "14%",
                sortable: false
            },
            {
                field: "PersonaName",
                headerName: t("sistema.consumos.grid.empleado"),
                width: "28%",
                sortable: false
            },
            {
                field: "PuestoNombre",
                headerName: t("sistema.consumos.grid.puesto"),
                width: "20%",
                sortable: false
            },
            {
                field: "CafeProdNombre",
                headerName: t("sistema.consumos.grid.tipoConsumo"),
                width: "18%",
                sortable: false,
                renderCell: (params) => {
                    return <>
                        <Stack direction="column">
                            <Typography sx={{ textWrap: "wrap" }} fontSize={(isMobile480 || isTablet768) ? fontSize.isMobile480 : fontSize.isTablet1024}>{params.row.CafeProdNombre}</Typography>
                            <Typography sx={{ textWrap: "wrap" }} fontSize={(isMobile480 || isTablet768) ? fontSize.isMobile480 : fontSize.isTablet1024}>{formatDate(params.row.CafeDocStamp, timeFormathhmmAMPM)}</Typography>
                        </Stack>
                    </>
                }
            }
        ];
    }

    return (
        <>
            <Stack direction="row" spacing={2} alignItems="center" >
                <Box sx={styles.spacer} />

                <GTIWebButton
                    text={t("sistema.acciones.hacerCorte")}
                    sx={
                        {
                            fontSize: (isMobile480 || isTablet768) ? "14px" : isTablet1024 ? "16px" : "20px",
                            height: (isMobile480 || isTablet768 || isTablet1024) ? "32px" : "43px",
                        }
                    }
                    onClick={props.hacerCorte} />

                <GTIWebButton
                    text={t("sistema.acciones.actualizar")}
                    icon={<Refresh sx={{ width: isLaptopDesktop ? "25px" : "20px", height: isLaptopDesktop ? "25px" : "20px" }} />}
                    sx={
                        {
                            fontSize: (isMobile480 || isTablet768) ? "14px" : isTablet1024 ? "16px" : "20px",
                            height: (isMobile480 || isTablet768 || isTablet1024) ? "32px" : "43px",
                        }
                    }
                    onClick={props.refreshConsumos}
                    color="secondary"
                />
            </Stack>

            <Stack direction="row" spacing={2} paddingTop={2} paddingBottom={8}>
                <GTIWebDataGrid
                    disableColumnMenu
                    pageSize={30}
                    loading={props.loading}
                    rows={props.consumos}
                    columns={columns}
                    getRowId={(r) => r.CafeDocID}
                    searchTextFieldAutoFocus={true}
                    exportedFileName={"consumos"}
                    rowHeight={(isMobile480 || isTablet768) ? 102 : isTablet1024 ? 132 : 172}
                    sx={
                        {
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: "bold",
                            },
                            fontSize: `${isMobile480 ? fontSize.isMobile480 : isTablet768 ? fontSize.isTablet768 : fontSize.isLaptopDesktop}`,
                            '.MuiDataGrid-cell': {
                                animation: "gridRowHighlight 5s",
                            },
                            '.MuiDataGrid-cellContent': {
                                textWrap: "wrap"
                            },
                        }
                    }

                />
            </Stack>
        </>
    )
}
